import { BookingContextProps } from './add-booking';

import DailyAvailabilityContainer from '../../components/DailyBooking';
import HourlyAvailabilityContainer from '../../components/HourlyBooking';
import { useNavigate, useOutletContext, useLocation } from 'react-router';
import Layout from '../../components/Layout';
import { BookingAvailabilityType } from '../../types/Bookings';
import NightlyBooking from '@/components/AmenityBooking/NightlyBooking';
import ByDayBooking from '@/components/AmenityBooking/ByDayBooking';
import Header from '@/components/AmenityBooking/Header';
import { useFeatureToggle } from '../features';
import { useRouteParams } from '@/hooks/useEncodedIds';

export default function SelectDateTimePage() {
  const params = useRouteParams<{
    leaseId: string;
    id: string;
    propertyId: string;
  }>();
  const navigate = useNavigate();
  const {
    booking,
    amenitySpace,
    setBooking,
    setSelectedHourlySlots,
    selectedHourlySlots
  } = useOutletContext<BookingContextProps>();
  const location =
    (useLocation().state as {
      returnTo: string;
      label: string;
    }) || {};
  const handleNext = () => navigate(`confirm`, { state: { ...location } });
  const isNightlyBookingEnabled = useFeatureToggle('nightly-booking') ?? false;

  const renderBookingContent = () => {
    if (
      amenitySpace.bookingAvailabilityType === BookingAvailabilityType.Daily
    ) {
      return (
        <HourlyAvailabilityContainer
          booking={booking}
          amenitySpace={amenitySpace}
          onNext={handleNext}
          onUpdateBooking={setBooking}
          selectedHourlySlots={selectedHourlySlots}
          setSelectedHourlySlots={setSelectedHourlySlots}
        />
      );
    }

    if (isNightlyBookingEnabled) {
      switch (amenitySpace.bookingAvailabilityType) {
        case BookingAvailabilityType.Overnight:
          return (
            <NightlyBooking
              booking={booking}
              onUpdateBooking={setBooking}
              amenitySpaceId={amenitySpace.amenitySpaceId}
              timezone={amenitySpace.timezone}
              minimumDuration={amenitySpace.minDuration || undefined}
              maximumDuration={amenitySpace.maxDuration || undefined}
              displayAvailabilityInDays={amenitySpace.displayAvailabilityInDays}
              onNext={handleNext}
            />
          );
        case BookingAvailabilityType.ByDay:
          return (
            <ByDayBooking
              booking={booking}
              onUpdateBooking={setBooking}
              amenitySpaceId={amenitySpace.amenitySpaceId}
              timezone={amenitySpace.timezone}
              displayAvailabilityInDays={amenitySpace.displayAvailabilityInDays}
              onNext={handleNext}
            />
          );
        default:
          return null;
      }
    }

    return (
      <DailyAvailabilityContainer
        booking={booking}
        amenitySpace={amenitySpace}
        onNext={handleNext}
        onUpdateBooking={setBooking}
      />
    );
  };

  const showNewHeader =
    isNightlyBookingEnabled &&
    (amenitySpace.bookingAvailabilityType === BookingAvailabilityType.ByDay ||
      amenitySpace.bookingAvailabilityType ===
        BookingAvailabilityType.Overnight);

  return (
    <Layout
      title="Amenity Booking"
      back={{
        to: `/lease/${params.leaseId}/amenities/${params.propertyId}/${params.id}`,
        label: amenitySpace.name || 'Amenity Space'
      }}
    >
      {showNewHeader && (
        <Header amenitySpace={amenitySpace} booking={booking} />
      )}
      {renderBookingContent()}
    </Layout>
  );
}
